import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap, mapTo, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { interval, of } from 'rxjs';
import { getUnitGroupsSuccess, getUnitGroupsFailure } from '../actions/unit-groups-api.actions';
import { UnitGroupsService } from '../../../units/services/unit-groups.service';
import { getUnitGroups } from '../actions/unit-groups.actions';
import * as UnitSharedActions from '../actions/units-shared.actions';
import { cacheLifeTime } from '../../../shared/config';

@Injectable()
export class UnitGroupsEffects {

  getUnitGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getUnitGroups, UnitSharedActions.getData),
      switchMap(() =>
        this.unitGroupsService.getUnitGroups().pipe(
          exhaustMap(unitGroups => of(getUnitGroupsSuccess({ unitGroups }))),
          catchError(error => of(getUnitGroupsFailure({ error })))
        )
      )
    )
  );

  persistUnitGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getUnitGroupsSuccess),
      tap((action) => {
        try {
          localStorage.setItem(`${environment.storagePrefix}.cachedUnitGroups`, JSON.stringify(action.unitGroups));
        } catch { }
      })
    ), { dispatch: false }
  );

  clear$ = createEffect(() =>
    interval(cacheLifeTime).pipe(
      mapTo(UnitSharedActions.clearData())
    )
  );

  constructor(
    private actions$: Actions,
    private unitGroupsService: UnitGroupsService
  ) { }
}